import { TranslateService } from '@ngx-translate/core';
import { PageResponse } from '@models/page-response';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseSearchingCriteria } from '@app/models/customer/company';
import { OnepageTemplate, OnepageTemplateConfig, OnePageTemplateConfigSearchingCriteria, OnePageTemplateSearchingCriteria } from '@app/models/onepage-template';
import { OnepageFieldOption } from '@app/models/onepage-template-field';
import { CommonResponse } from '@app/models/common-model';


@Injectable()
export class OnepageTemplateConfigService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: OnePageTemplateConfigSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<OnepageTemplateConfig>> {

        let params: HttpParams = new HttpParams();
        params = params.set('global', globalCriteria);
        params = params.set('criteria', JSON.stringify(criteria == null ? new OnePageTemplateConfigSearchingCriteria() : criteria));
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        if (sortField != null) {
            params = params.set('sort', sortField + ',' + sortDirection);
        }

        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplateConfig`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => {
                    let tempObj = <OnepageTemplateConfig[]>(<any>response);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    insert(emailTemplate: OnepageTemplateConfig): Observable<OnepageTemplateConfig> {

        let body = JSON.stringify(emailTemplate);

        return this.httpClient.post(`${environment.API_END_POINT}/onepageTemplateConfig`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <OnepageTemplateConfig[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    get(id: string, forDeploy: any='N'): Observable<OnepageTemplateConfig> {
        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplateConfig/${id}?forDeploy=${forDeploy}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <OnepageTemplateConfig>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    
    loadTemplateConfig(htmlTemplateName: string): Observable<OnepageTemplateConfig> {
        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplateConfig/byTemplateName/${htmlTemplateName}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <OnepageTemplateConfig>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }


    
    getButtonFieldIdList(id: string): Observable<OnepageFieldOption[]> {
        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplateConfig/buttonFieldIdList/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <OnepageFieldOption[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    update(emailTemplate: OnepageTemplateConfig): Observable<OnepageTemplateConfig> {
      
        let body = JSON.stringify(emailTemplate);

        return this.httpClient.put(`${environment.API_END_POINT}/onepageTemplateConfig/${emailTemplate.id}`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <OnepageTemplateConfig>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    deploy(templateId: string): Observable<string> {

        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplateConfig/deploy/${templateId}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    // let tempObj = <OnepageTemplate[]>((<any>response).content);
                    return response;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    copy(templateId: string): Observable<string> {

        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplateConfig/copy/${templateId}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    // let tempObj = <OnepageTemplate[]>((<any>response).content);
                    return response;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    findAll(): Observable<OnepageTemplateConfig[]> {


        return this.httpClient.get(`${environment.API_END_POINT}/onepageTemplateConfig/all`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <OnepageTemplateConfig[]>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    
    delete(templateId: string): Observable<CommonResponse> {

        return this.httpClient.delete(`${environment.API_END_POINT}/onepageTemplateConfig/${templateId}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    return response;
                }),
                catchError((error: Response | any) => {
                    return this.commonService.handleHttpError(error);
                })
            );

    }

}